<template>
  <section>
    <PageTitle>Opret nyt præparat</PageTitle>
    <section>
      <CreatePreparation
        @created="onCreated"
        :default-item="defaultItem"
      />
    </section>
  </section>
</template>

<script>
import CreatePreparation from '../../components/Forms/Preparations/CreatePreparation.vue';

export default {
    name: 'CreatePreparationContainer',
    components: { CreatePreparation },
    props: {
        defaultItem: { type: Object, default: () => {} },
    },
    methods: {
        onCreated(payload) {
            this.$router.push({
                name: 'preparations.single',
                params: { id: payload.info.id },
                query: { date: window.moment.utc(payload.info.publishDate).local().format('YYYY-MM-DD HH:mm') },
            });
        },
    },
};
</script>
